var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { parseToRgb, toColorString, hslToColorString } from 'polished';
import { logger } from '../../utils/logger';
export var alphaHex = function (value) { return function (hex) {
    return toColorString(__assign({}, parseToRgb(hex), { alpha: value }));
}; };
export var hslaToHex = function (hsla) {
    var values = hsla.replace(/(hsla\(|hsl\(|\)|\%|\s)/g, '').split(',');
    var hue = parseInt(values[0], 10);
    var saturationPercentage = parseInt(values[1], 10);
    var lightnessPercentage = parseInt(values[2], 10);
    var saturation = saturationPercentage / 100;
    var lightness = lightnessPercentage / 100;
    if (!Number.isInteger(hue) ||
        !Number.isInteger(saturationPercentage) ||
        !Number.isInteger(lightnessPercentage)) {
        logger.error('Not a CSS compatible HSLA or HSL color:', hsla);
        return false;
    }
    return hslToColorString({
        hue: hue,
        saturation: saturation,
        lightness: lightness,
    });
};
//# sourceMappingURL=colors.js.map